@if (showNodeUserMenuItems) {
  <div>
    @if (folderIsEmpty) {
      <div class="alert alert-light text-center">
        <i class="fa-solid fa-folder-open"></i>
        {{ 'This folder is empty' | translate }}.
      </div>
    }
    @if (!folderIsEmpty) {
      <div class="menu-user-node">
        @for (item of nodeUserMenuItems; track item) {
          <div class="scitis-menu-item" [ngClass]="getClass(item)">
            <a href="#" (click)="onClick($event, item)" class="scitis-menu-item-content"
              [ngClass]="item.isFavorite ? 'scitis-menu-item-content-favorite' : ''">
              <span class="menu-item-icon">
                <span [ngClass]="item.icon"></span>
              </span>
              <span class="menu-item-title" [innerText]="item.name"></span>
              <div class="menu-item-functions">
                <button (click)="toggleFavorite($event, item)"
                  [ngbTooltip]="getTooltip(item) | async"
                  class="btn btn-xs btn-secondary"
                  placement="left"
                  tooltipClass="text-nowrap">
                  <span [ngClass]="item.isFavorite ? 'fa-solid fa-star' : 'fa-solid fa-star'"></span>
                </button>
              </div>
            </a>
          </div>
        }
      </div>
    }
  </div>
}
